import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
} from "@material-ui/core";
import { compose } from "ramda";
import { ChangeEvent, memo } from "react";
import { Control, Controller, UseFormMethods } from "react-hook-form";

import { RootState } from "../../store";
import { withError } from "../HOC";
import { CommonFormElProps } from "../types";

export type SelectItem = {
  readonly label: string;
  readonly value: string;
};

export type SelectProps = {
  readonly items: Array<SelectItem>;
  readonly control: Control;
  readonly trigger: UseFormMethods["trigger"];
} & CommonFormElProps;

export const Select = memo<SelectProps>(
  ({
    control,
    defaultValue,
    disabled: isDisabled,
    hasError,
    id,
    items,
    label,
    onChange: onChageAction,
    required = false,
    trigger,
  }) => (
    <FormControl>
      <InputLabel
        shrink
        disabled={isDisabled}
        required={!isDisabled && required}
      >
        {label}
      </InputLabel>
      <Controller
        name={id}
        control={control}
        defaultValue={defaultValue}
        render={({ onChange, ...props }) => (
          <MuiSelect
            disabled={isDisabled}
            error={hasError}
            onChange={(e: ChangeEvent<{ value: unknown }>) => {
              onChange(e.target.value);
              onChageAction(e.target.value);
              trigger(id);
            }}
            onBlur={() => {
              trigger(id);
            }}
            id={id}
            variant="outlined"
            value={props.value}
          >
            {items.map(({ label, value }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </MuiSelect>
        )}
      />
    </FormControl>
  )
);

export const SelectWithError = compose(withError)(Select);
